/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TrainingIndexRouteImport } from './routes/training/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as ModelsIndexRouteImport } from './routes/models/index'
import { Route as InferenceIndexRouteImport } from './routes/inference/index'
import { Route as DatasetsIndexRouteImport } from './routes/datasets/index'
import { Route as TrainingNewRouteImport } from './routes/training/new'
import { Route as TrainingJobIdRouteImport } from './routes/training/$jobId'
import { Route as SettingsBillingRouteImport } from './routes/settings/billing'
import { Route as SettingsApiKeysRouteImport } from './routes/settings/api-keys'
import { Route as ModelsModelIdRouteImport } from './routes/models/$modelId'
import { Route as InferenceNewRouteImport } from './routes/inference/new'
import { Route as InferenceJobIdRouteImport } from './routes/inference/$jobId'
import { Route as DatasetsNewRouteImport } from './routes/datasets/new'
import { Route as AuthSignUpRouteImport } from './routes/_auth/sign-up'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as DatasetsDatasetIdIndexRouteImport } from './routes/datasets/$datasetId/index'
import { Route as DatasetsDatasetIdUploadRouteImport } from './routes/datasets/$datasetId/upload'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TrainingIndexRoute = TrainingIndexRouteImport.update({
  id: '/training/',
  path: '/training/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const ModelsIndexRoute = ModelsIndexRouteImport.update({
  id: '/models/',
  path: '/models/',
  getParentRoute: () => rootRouteImport,
} as any)
const InferenceIndexRoute = InferenceIndexRouteImport.update({
  id: '/inference/',
  path: '/inference/',
  getParentRoute: () => rootRouteImport,
} as any)
const DatasetsIndexRoute = DatasetsIndexRouteImport.update({
  id: '/datasets/',
  path: '/datasets/',
  getParentRoute: () => rootRouteImport,
} as any)
const TrainingNewRoute = TrainingNewRouteImport.update({
  id: '/training/new',
  path: '/training/new',
  getParentRoute: () => rootRouteImport,
} as any)
const TrainingJobIdRoute = TrainingJobIdRouteImport.update({
  id: '/training/$jobId',
  path: '/training/$jobId',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsBillingRoute = SettingsBillingRouteImport.update({
  id: '/settings/billing',
  path: '/settings/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsApiKeysRoute = SettingsApiKeysRouteImport.update({
  id: '/settings/api-keys',
  path: '/settings/api-keys',
  getParentRoute: () => rootRouteImport,
} as any)
const ModelsModelIdRoute = ModelsModelIdRouteImport.update({
  id: '/models/$modelId',
  path: '/models/$modelId',
  getParentRoute: () => rootRouteImport,
} as any)
const InferenceNewRoute = InferenceNewRouteImport.update({
  id: '/inference/new',
  path: '/inference/new',
  getParentRoute: () => rootRouteImport,
} as any)
const InferenceJobIdRoute = InferenceJobIdRouteImport.update({
  id: '/inference/$jobId',
  path: '/inference/$jobId',
  getParentRoute: () => rootRouteImport,
} as any)
const DatasetsNewRoute = DatasetsNewRouteImport.update({
  id: '/datasets/new',
  path: '/datasets/new',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRoute,
} as any)
const DatasetsDatasetIdIndexRoute = DatasetsDatasetIdIndexRouteImport.update({
  id: '/datasets/$datasetId/',
  path: '/datasets/$datasetId/',
  getParentRoute: () => rootRouteImport,
} as any)
const DatasetsDatasetIdUploadRoute = DatasetsDatasetIdUploadRouteImport.update({
  id: '/datasets/$datasetId/upload',
  path: '/datasets/$datasetId/upload',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/datasets/new': typeof DatasetsNewRoute
  '/inference/$jobId': typeof InferenceJobIdRoute
  '/inference/new': typeof InferenceNewRoute
  '/models/$modelId': typeof ModelsModelIdRoute
  '/settings/api-keys': typeof SettingsApiKeysRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/training/$jobId': typeof TrainingJobIdRoute
  '/training/new': typeof TrainingNewRoute
  '/datasets': typeof DatasetsIndexRoute
  '/inference': typeof InferenceIndexRoute
  '/models': typeof ModelsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/training': typeof TrainingIndexRoute
  '/datasets/$datasetId/upload': typeof DatasetsDatasetIdUploadRoute
  '/datasets/$datasetId': typeof DatasetsDatasetIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/datasets/new': typeof DatasetsNewRoute
  '/inference/$jobId': typeof InferenceJobIdRoute
  '/inference/new': typeof InferenceNewRoute
  '/models/$modelId': typeof ModelsModelIdRoute
  '/settings/api-keys': typeof SettingsApiKeysRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/training/$jobId': typeof TrainingJobIdRoute
  '/training/new': typeof TrainingNewRoute
  '/datasets': typeof DatasetsIndexRoute
  '/inference': typeof InferenceIndexRoute
  '/models': typeof ModelsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/training': typeof TrainingIndexRoute
  '/datasets/$datasetId/upload': typeof DatasetsDatasetIdUploadRoute
  '/datasets/$datasetId': typeof DatasetsDatasetIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_auth/sign-up': typeof AuthSignUpRoute
  '/datasets/new': typeof DatasetsNewRoute
  '/inference/$jobId': typeof InferenceJobIdRoute
  '/inference/new': typeof InferenceNewRoute
  '/models/$modelId': typeof ModelsModelIdRoute
  '/settings/api-keys': typeof SettingsApiKeysRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/training/$jobId': typeof TrainingJobIdRoute
  '/training/new': typeof TrainingNewRoute
  '/datasets/': typeof DatasetsIndexRoute
  '/inference/': typeof InferenceIndexRoute
  '/models/': typeof ModelsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/training/': typeof TrainingIndexRoute
  '/datasets/$datasetId/upload': typeof DatasetsDatasetIdUploadRoute
  '/datasets/$datasetId/': typeof DatasetsDatasetIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sign-in'
    | '/sign-up'
    | '/datasets/new'
    | '/inference/$jobId'
    | '/inference/new'
    | '/models/$modelId'
    | '/settings/api-keys'
    | '/settings/billing'
    | '/training/$jobId'
    | '/training/new'
    | '/datasets'
    | '/inference'
    | '/models'
    | '/settings'
    | '/training'
    | '/datasets/$datasetId/upload'
    | '/datasets/$datasetId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sign-in'
    | '/sign-up'
    | '/datasets/new'
    | '/inference/$jobId'
    | '/inference/new'
    | '/models/$modelId'
    | '/settings/api-keys'
    | '/settings/billing'
    | '/training/$jobId'
    | '/training/new'
    | '/datasets'
    | '/inference'
    | '/models'
    | '/settings'
    | '/training'
    | '/datasets/$datasetId/upload'
    | '/datasets/$datasetId'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_auth/sign-in'
    | '/_auth/sign-up'
    | '/datasets/new'
    | '/inference/$jobId'
    | '/inference/new'
    | '/models/$modelId'
    | '/settings/api-keys'
    | '/settings/billing'
    | '/training/$jobId'
    | '/training/new'
    | '/datasets/'
    | '/inference/'
    | '/models/'
    | '/settings/'
    | '/training/'
    | '/datasets/$datasetId/upload'
    | '/datasets/$datasetId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  DatasetsNewRoute: typeof DatasetsNewRoute
  InferenceJobIdRoute: typeof InferenceJobIdRoute
  InferenceNewRoute: typeof InferenceNewRoute
  ModelsModelIdRoute: typeof ModelsModelIdRoute
  SettingsApiKeysRoute: typeof SettingsApiKeysRoute
  SettingsBillingRoute: typeof SettingsBillingRoute
  TrainingJobIdRoute: typeof TrainingJobIdRoute
  TrainingNewRoute: typeof TrainingNewRoute
  DatasetsIndexRoute: typeof DatasetsIndexRoute
  InferenceIndexRoute: typeof InferenceIndexRoute
  ModelsIndexRoute: typeof ModelsIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  TrainingIndexRoute: typeof TrainingIndexRoute
  DatasetsDatasetIdUploadRoute: typeof DatasetsDatasetIdUploadRoute
  DatasetsDatasetIdIndexRoute: typeof DatasetsDatasetIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/training/': {
      id: '/training/'
      path: '/training'
      fullPath: '/training'
      preLoaderRoute: typeof TrainingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/models/': {
      id: '/models/'
      path: '/models'
      fullPath: '/models'
      preLoaderRoute: typeof ModelsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inference/': {
      id: '/inference/'
      path: '/inference'
      fullPath: '/inference'
      preLoaderRoute: typeof InferenceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/datasets/': {
      id: '/datasets/'
      path: '/datasets'
      fullPath: '/datasets'
      preLoaderRoute: typeof DatasetsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/training/new': {
      id: '/training/new'
      path: '/training/new'
      fullPath: '/training/new'
      preLoaderRoute: typeof TrainingNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/training/$jobId': {
      id: '/training/$jobId'
      path: '/training/$jobId'
      fullPath: '/training/$jobId'
      preLoaderRoute: typeof TrainingJobIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/billing': {
      id: '/settings/billing'
      path: '/settings/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof SettingsBillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/api-keys': {
      id: '/settings/api-keys'
      path: '/settings/api-keys'
      fullPath: '/settings/api-keys'
      preLoaderRoute: typeof SettingsApiKeysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/models/$modelId': {
      id: '/models/$modelId'
      path: '/models/$modelId'
      fullPath: '/models/$modelId'
      preLoaderRoute: typeof ModelsModelIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inference/new': {
      id: '/inference/new'
      path: '/inference/new'
      fullPath: '/inference/new'
      preLoaderRoute: typeof InferenceNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inference/$jobId': {
      id: '/inference/$jobId'
      path: '/inference/$jobId'
      fullPath: '/inference/$jobId'
      preLoaderRoute: typeof InferenceJobIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/datasets/new': {
      id: '/datasets/new'
      path: '/datasets/new'
      fullPath: '/datasets/new'
      preLoaderRoute: typeof DatasetsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/sign-up': {
      id: '/_auth/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRoute
    }
    '/datasets/$datasetId/': {
      id: '/datasets/$datasetId/'
      path: '/datasets/$datasetId'
      fullPath: '/datasets/$datasetId'
      preLoaderRoute: typeof DatasetsDatasetIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/datasets/$datasetId/upload': {
      id: '/datasets/$datasetId/upload'
      path: '/datasets/$datasetId/upload'
      fullPath: '/datasets/$datasetId/upload'
      preLoaderRoute: typeof DatasetsDatasetIdUploadRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AuthRouteChildren {
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  DatasetsNewRoute: DatasetsNewRoute,
  InferenceJobIdRoute: InferenceJobIdRoute,
  InferenceNewRoute: InferenceNewRoute,
  ModelsModelIdRoute: ModelsModelIdRoute,
  SettingsApiKeysRoute: SettingsApiKeysRoute,
  SettingsBillingRoute: SettingsBillingRoute,
  TrainingJobIdRoute: TrainingJobIdRoute,
  TrainingNewRoute: TrainingNewRoute,
  DatasetsIndexRoute: DatasetsIndexRoute,
  InferenceIndexRoute: InferenceIndexRoute,
  ModelsIndexRoute: ModelsIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  TrainingIndexRoute: TrainingIndexRoute,
  DatasetsDatasetIdUploadRoute: DatasetsDatasetIdUploadRoute,
  DatasetsDatasetIdIndexRoute: DatasetsDatasetIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
